import styled from "styled-components";

export const MyProjectsContainer = styled.div`
    height: auto;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    padding: 20px 0;
    
    @media (max-width: 446.9px) {
      display: flex;
      flex-direction: column;
    }
  `
